import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import React, { useRef } from 'react'

interface ConfirmErrorDialogProps {
  isOpen: boolean
  errorMessages: string[]
  onClose: () => void
}

export const ConfirmErrorDialog: React.FC<ConfirmErrorDialogProps> = ({
  isOpen,
  errorMessages,
  onClose,
}) => {
  const { translate } = useTranslationsContext()
  const cancelRef = useRef<HTMLButtonElement>(null)

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {translate('error', 'Chyba')}
          </AlertDialogHeader>

          <AlertDialogBody>
            {translate(
              'quoteItem.sidebar.confirmErrorDialogMessage',
              'Při potvrzení kalkulace došlo k chybě.',
            )}
            <br /> <br />
            <UnorderedList>
              {errorMessages.map((x) => (
                <ListItem key={x}>{x}</ListItem>
              ))}
            </UnorderedList>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              variant="solid"
              colorScheme="gray"
              onClick={onClose}
              ref={cancelRef}
            >
              {translate('ok', 'OK').toUpperCase()}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
